module.exports = __webpack_public_path__ + "static/scale-model-of-sea-turtle-op-headquarters-in-fort-lauderdale-florida-1f901b35a12a217347c81826c372a43e.png";